import React, { useEffect, useState } from "react";
import { Button, Col, Row, Input } from "antd";
import FormConfig from '../../Config/FormConfig.js'
import { Formik } from 'formik';
import * as yup from "yup";
import Swal from "sweetalert2";
import APIService from "../../Service/APIService";

const InvoiceHomeOrderProductsEdit = (props) => {

  const { data } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const [isPrepaidInvoice, setIsPrepaidInvoice] = useState(
    typeof data?.PrepaidOrder === "boolean" ? data.PrepaidOrder : null
  );
  const [isInvoiceStateLoading, setIsInvoiceStateLoading] = useState(
    typeof data?.PrepaidOrder !== "boolean"
  );

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    console.log("Data: ", data);
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] =
          cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    console.log("Initial Values:", obj);
    return obj;
  }

  const generateFieldsArray = (data) => {
    const fields = FormConfig.InvoiceHomeOrderProducts;
    const val = generateInitialValues(fields, data);
    console.log("Val: ", val);
    if (typeof val["Price"] === "string" && val["Price"].includes("$")) {
      val["Price"] = val["Price"].replace("$", "");
      val["Price"] = val["Price"].replace(",", "");
    }
    console.log("initial values: ", val);
    setInitialValues(val);
    return fields;
  }

  const generateValidationSchema = (formFieldArr) => {
    let obj = {}; // schema object
    for (const cur of formFieldArr) {
      obj[cur.backendName] = cur.validationFunction;
    }
    return obj;
  }

  useEffect(() => {
    console.log("props: ", data);
    console.log("TissueID", data.TissueID);
    const val = generateFieldsArray(data);
    console.log("Fields: ", val);
    setValidationSchema(yup.object().shape(generateValidationSchema(val)));
  }, [data]);

  useEffect(() => {
    const fetchInvoiceState = async () => {
      if (typeof data?.PrepaidOrder === "boolean") {
        setIsPrepaidInvoice(data.PrepaidOrder);
        setIsInvoiceStateLoading(false);
        return;
      }

      if (!data?.InvoiceID) {
        setIsPrepaidInvoice(false);
        setIsInvoiceStateLoading(false);
        return;
      }

      setIsInvoiceStateLoading(true);
      const apiServe = new APIService();
      try {
        const response = await apiServe.getDataFromBackend(
          `getinvoicebyid?ID=${data.InvoiceID}`
        );
        setIsPrepaidInvoice(Boolean(response?.data?.data?.PrepaidOrder));
      } catch (error) {
        console.error("Failed to fetch invoice state", error);
        setIsPrepaidInvoice(null);
        Swal.fire({
          title: "Error!",
          text: "Unable to verify whether this invoice product can be edited.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } finally {
        setIsInvoiceStateLoading(false);
      }
    };

    fetchInvoiceState();
  }, [data?.InvoiceID, data?.PrepaidOrder]);

  const submitHandler = (values) => {
    if (isPrepaidInvoice) {
      Swal.fire({
        icon: "error",
        title: "Edits Not Allowed",
        text: "Invoice products cannot be edited for prepaid invoices.",
      });
      return;
    }

    if (isInvoiceStateLoading || isPrepaidInvoice === null) {
      Swal.fire({
        icon: "error",
        title: "Edit Unavailable",
        text: "Invoice edit permissions are still loading. Please try again.",
      });
      return;
    }

    console.log("Form Values: ", values);
    // return;
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to update this product?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#27a907',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const apiServe = new APIService();
          const response = await apiServe.updateDataToBackend(values, "updateinvoiceproducts?type=InvoiceHomeOrderProductsEdit");
          console.log("Response from backend: ", response);
          if (response?.status == 200 || response?.status == 201) {
            Swal.fire(
              'Updated!',
              'Product has been updated.',
              'success'
            ).then(() => {
              window.location.reload();
            });
            return;
          }

          Swal.fire(
            'Failed!',
            'Product update failed.',
            'error'
          );
        } catch (error) {
          Swal.fire(
            'Failed!',
            error?.response?.data?.message ||
              error?.response?.data?.data ||
              'Product update failed.',
            'error'
          );
        }
      }
    });
  }


  return (
    <div>
      {initialValues && (
        <Formik onSubmit={submitHandler} initialValues={initialValues}>
          {(formik) => (
            // console.log("formik: ", formik),
            <form onSubmit={formik.handleSubmit}>
              {isPrepaidInvoice && (
                <div
                  style={{
                    marginBottom: "16px",
                    padding: "12px 16px",
                    border: "1px solid #ffd8bf",
                    borderRadius: "8px",
                    background: "#fff7e6",
                    color: "#ad4e00",
                  }}
                >
                  Invoice products cannot be edited for prepaid invoices.
                </div>
              )}
              <Row gutter={16}>
                <Col span={8} style={{ width: '100%' }}>
                  <label className="form-label">Tissue ID</label>
                  <Input
                    name="TissueID"
                    value={formik.values.TissueID}
                    disabled
                  />
                </Col>
                <Col span={8} style={{ width: '100%' }}>
                  <label className="form-label">Product Code</label>
                  <Input
                    name="ProductCode"
                    value={formik.values.ProductCode}
                    disabled
                  />
                </Col>
                <Col span={8} style={{ width: '100%' }}>
                  <label className="form-label">Product Cost</label>
                  <Input
                    name="Price"
                    value={formik.values.Price}
                    onChange={formik.handleChange}
                    disabled={Boolean(isPrepaidInvoice) || isInvoiceStateLoading}
                  />
                </Col>
              </Row>
              <Button
                type="primary"
                onClick={() => formik.handleSubmit()}
                style={{ background: '#27a907', marginTop: '10px' }}
                disabled={Boolean(isPrepaidInvoice) || isInvoiceStateLoading || isPrepaidInvoice === null}
              >
                Update
              </Button>
            </form>
          )}
        </Formik>
      )}
    </div>
  )
}

export default InvoiceHomeOrderProductsEdit;
